<template>
    <div class="country-pe" :class="$x.nsAddressForm">
        <VTextField
            v-model="address.address1"
            name="address1"
            maxlength="35"
            required
            validate-on-blur
            :label="t.address1Label"
            class="flex-column"
            :rules="address1Rules"
            @blur="onBlur"
            @input="addressUpdated"
        ></VTextField>
        <VTextField
            v-model="address.address2"
            name="address2"
            maxlength="35"
            validate-on-blur
            class="flex-column"
            :aria-label="t.address2Label"
            :rules="address2Rules"
            @blur="onBlur"
            @input="addressUpdated"
        >
            <template #label>
                {{ t.address2Label }}
                <span :class="$x.optional"> {{ t.optional }} </span>
            </template>
        </VTextField>
        <div :class="$x.dualColumn">
            <NsSelect
                ref="regionSelect"
                v-model="address.region"
                :items="regions"
                name="region"
                :label="t.regionLabel"
                :rules="requiredRule"
                :class="$x.firstCol"
                @blur="onBlur"
                @input="regionUpdated"
            ></NsSelect>
            <NsSelect
                ref="districtSelect"
                v-model="address.district"
                :items="districts"
                name="district"
                :label="t.districtLabel"
                :rules="requiredRule"
                @blur="onBlur"
                @input="districtUpdated"
            ></NsSelect>
        </div>
        <div :class="$x.dualColumn">
            <NsSelect
                ref="citySelect"
                v-model="address.city"
                :items="cities"
                name="city"
                :label="t.cityLabel"
                :rules="requiredRule"
                @blur="onBlur"
                @input="addressUpdated"
            ></NsSelect>
            <!-- <VTextField
                v-model="address.postalCode"
                name="postalCode"
                maxlength="5"
                required
                validate-on-blur
                :label="t.postalCodeLabel"
                class="flex-column"
                :rules="postalCodeRules"
                @blur="onBlur"
                @input="addressUpdated"
            ></VTextField> -->
        </div>
        <VTextField
            v-if="includeEmail"
            v-model="address.email"
            name="email"
            maxlength="50"
            required
            validate-on-blur
            :label="t.emailLabel"
            class="flex-column"
            :rules="emailRules"
            @input="addressUpdated"
            @blur="onBlur"
        ></VTextField>
    </div>
</template>

<script>
import { VTextField } from 'vuetify/lib';
import {NsSelect} from '@nuskin/design-components';
import ADDRESS_MIXIN from '../addressMixin';
import REGIONS from './regions';
import REGION_DISTRICT_CITY_MAPPING from './regionDistrictCity.json';
// Most of the logic for this component is in the mixin
import TRANSLATIONS from './translations';

export default {
    name: 'NsAddressPe',
    components: {
        VTextField,
        NsSelect,
    },
    mixins: [ADDRESS_MIXIN],
    data() {
        return {
            regions: REGIONS,
            districts: [],
            cities: [],
        };
    },
    mounted() {
        this.address.country = 'PE';
        if (TRANSLATIONS[this.lang]) {
            this.t = TRANSLATIONS[this.lang];
        } else {
            // If the language isn't available then get the first language in translations file
            this.t = TRANSLATIONS[Object.keys(TRANSLATIONS)[0]];
        }

        const regionData = REGION_DISTRICT_CITY_MAPPING[this.address.region] || {};
        this.districts = Object.keys(regionData);
        this.cities = regionData[this.address.district] || [];

        // check region, district, and city from saved address against options
        if (this.address.region && !regionData) {
            // region ("Departamento") doesn't match options
            this.address.region = null;
            this.address.district = null;
            this.address.city = null;
        } else if (this.address.district && !this.districts.includes(this.address.district)) {
            // region is fine, but district ("Provincia") doesn't match options
            this.address.district = null;
            this.address.city = null;
        } else if (this.address.city && !this.cities.includes(this.address.city)) {
            // region and district are fine, but city ("Distrito") doesn't match options
            this.address.city = null;
        }

        this.$emit('new-address-in-form');
    },
    methods: {
        regionUpdated() {
            const regionData = REGION_DISTRICT_CITY_MAPPING[this.address.region] || {};
            this.districts = Object.keys(regionData);

            if (this.address.district && !this.districts.includes(this.address.district)) {
                // district doesn't match new options
                this.address.district = null;
                this.address.city = null;
            }
            this.addressUpdated();
        },
        districtUpdated() {
            const regionData = REGION_DISTRICT_CITY_MAPPING[this.address.region] || {};
            this.cities = regionData[this.address.district] || [];

            if (this.address.city && !this.cities.includes(this.address.city)) {
                // city doesn't match new options
                this.address.city = null;
            }
            this.addressUpdated();
        },
    },
};
</script>

<style lang="scss" module="$x">
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";

$color-eeyore: map.get(colors.$baseColors, eyore);

::v-deep *:not(.v-icon) {
  font-family: map.get(typographyVariables.$typography, font-family-primary);
}

.nsAddressForm {
  .dualColumn {
    display: flex;
    align-content: space-between;
    .firstCol {
      margin-right: 20px;
    }
  }
}

.optional {
  color: $color-eeyore;
}
</style>
